require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-static-sites-are-great.json") })
        }
      }, "path---blog-static-sites-are-great");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-static-sites-are-great!./.cache/json/blog-static-sites-are-great.json
// module id = 378
// module chunks = 231608221292675